import z from 'zod';
import { entity, customerRef, string, url, datetime, } from '../common';
export var DbOperations;
(function (DbOperations) {
    DbOperations["Create"] = "create";
    DbOperations["Update"] = "update";
    DbOperations["Remove"] = "remove";
})(DbOperations || (DbOperations = {}));
export var DeliveryMethods;
(function (DeliveryMethods) {
    DeliveryMethods["POST"] = "POST";
    DeliveryMethods["GET"] = "GET";
    DeliveryMethods["PUT"] = "PUT";
    DeliveryMethods["PATCH"] = "PATCH";
    DeliveryMethods["DELETE"] = "DELETE";
})(DeliveryMethods || (DeliveryMethods = {}));
export const webhookQuery = z.object({
    operation: z.nativeEnum(DbOperations),
    entityTypes: string.array(),
    filter: z.record(z.any()),
});
export const deliveryStats = z.object({
    lastDeliveryDate: datetime.nullish().default(null),
    numDeliverySucceeded: z.number().default(0),
    numDeliveryFailed: z.number().default(0),
});
export const deliveryConfig = z.object({
    url,
    method: z.nativeEnum(DeliveryMethods),
    headers: z.record(z.any()).nullable().default(null),
});
export const webhook = z.object({
    ...entity.shape,
    customer: customerRef.nullable(),
    migrationKey: string.nullish(),
    webhookQuery,
    deliveryStats: deliveryStats.default({}),
    deliveryConfig,
    transformer: string.nullable().default(null),
    enableWebhook: z.boolean().default(true),
});
